import React from "react";
import { Typography, Link } from '@mui/material';
import { LockOutlined as Icon } from '@mui/icons-material';
import { CatalogEnabledProps } from '../shared/types';

function withCatalogEnabled<P extends object>(
    WrappedComponent: React.ComponentType<P>,
    missingCoId?: unknown,
): React.ComponentType<P & CatalogEnabledProps> {
    return class extends React.Component<P & CatalogEnabledProps> {

    render() {
        let style = {fontSize: '16pt'};
      if(!this.props.catalogEnabled){
          return <div style={{color: '#888'}}>
              <Icon style={{fontSize: "20em"}}/>
              <Typography style={style}>
                To manage your catalog through Logicbroker you will need to be set up by a member of our team.
              </Typography>
              <Typography style={style}>
                Ready to start? <Link target="_blank" rel="noopener noreferrer" href='https://info.logicbroker.com/connected-commerce-network-brands'>Contact us today</Link>
              </Typography>
          </div>;
      }
      return <WrappedComponent {...(this.props as P)} />;
    }
  };
}

const withCatalogEnabledExport = <P extends object>(
    component: React.ComponentType<P>,
    missingCoId?: unknown,
): React.ComponentType<P & CatalogEnabledProps> => withCatalogEnabled(component, missingCoId);
export default withCatalogEnabledExport;
